import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  ErrorResponseMessageType,
  ErrorConfig,
  HttpStatusCode,
  AppMessages
} from '../constants/app.constant';
import { StaticService } from '../services/static/static.service';
import { MessageService } from '../services/message.service';
import { AuthService } from '../services/auth.service';
import { AppUtilService } from '../utils/app-util.service';
import { PublisherService } from '../services/publisher.service';
import { CacheConstant } from '../constants/app.constant';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /***************Properties***************/
  private handledSessionExpiration: Boolean = false;
  callBackURL: string;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private authService: AuthService,
    private staticService: StaticService,
    private messageService: MessageService
  ) {}
  /***************Constructor***************/

  /******************Implementation Methods******************/

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (error: any) => {
          if (error instanceof HttpErrorResponse && error.error) {
            const response = error.error;
              
            if(error.headers.get("x-invalid-token") && AppUtilService.cache.get(CacheConstant.Show_Login_Popup) !== false){

              PublisherService.notifySignOutRequest();
              this.callBackURL = window.location.pathname;

              if ((this.callBackURL.indexOf('/order/review') > -1) || (this.callBackURL.indexOf('/order/summary') > -1) || (this.callBackURL.indexOf('/dscsa-transaction-data') > -1)) {
                  this.callBackURL = '/myhome'
              }
               
              PublisherService.notifySignInRequest({ isSessionTimeout: true, callBackUrl: this.callBackURL });
            }
            // Commented below code as Product Owner didn't want toaster on session expiration.
            // Only login popup should open when user tries to click on secure link after session expiration.
            // Refer Card 695 acceptance criteria
            // ------------------------------------
            // if (this.isSessionExpired(response)) {
            //   this.authService.signout();
            //   this.handledSessionExpiration = true;
            //   const message = response.faultInfos[0].faultMessage;
            //   this.messageService.error(
            //     message,
            //     AppMessages.SessionExpiredTitle
            //   );
            // }
            // ------------------------------------

            // if (this.isSystemException(response)) {
            //   const message = this.getSystemExceptionMessage(response);
            //   this.messageService.error(message);
            // }

            // if (this.handleBusinessException(response)) {
            //   const message = this.getBusinessExceptionMessage(response);
            //   this.messageService.error(message);
            // }

            error.error.hasError = true;
            error.error.status = error.status;
            error.error.statusText = error.statusText;
          }
        }
      )
    );
  }

  /******************Implementation Methods******************/

  /******************Private Methods******************/

  private isSessionExpired(response: any): boolean {
    return response.logoutUser && !this.handledSessionExpiration;
  }

  private isSystemException(response: any) {
    let systemException = !response ? true : false;

    if (response && !response.businessFault && !response.logoutUser) {
      systemException =
        !response.messageDisplay ||
        response.messageDisplay === ErrorResponseMessageType.Toastr;
    }

    return systemException;
  }

  private handleBusinessException(response: any) {
    return (
      response.businessFault &&
      !response.logoutUser &&
      response.messageDisplay === ErrorResponseMessageType.Toastr
    );
  }

  private getSystemExceptionMessage(response: any) {
    let messageId = ErrorConfig.SysErrId;

    if (response && response.faultInfos) {
      messageId = response.faultInfos[0].faultCode;
    } else if (!response) {
      switch (response.status) {
        case HttpStatusCode.BadRequest:
          messageId = ErrorConfig.BadRequestId;
          break;

        case HttpStatusCode.NotFound:
          messageId = ErrorConfig.NotFoundId;
          break;

        case HttpStatusCode.PreconditionRequired:
          messageId = ErrorConfig.PreconditionRequiredId;
          break;

        case HttpStatusCode.Timeout:
          messageId = ErrorConfig.TimeoutId;
          break;
      }
    }

    const message = this.staticService.message.get(messageId);
    return !message ? AppMessages.GenericErrorMessage : message.messageDesc;
  }

  private getBusinessExceptionMessage(response: any) {
    let message = null;

    if (response.useServerMessage) {
      message = response.faultInfos[0].faultMessage;
    } else {
      const ref = this.staticService.message.get(
        response.faultInfos[0].faultCode
      );
      message = !ref ? AppMessages.GenericErrorMessage : ref.messageDesc;
    }

    return message;
  }

  /******************Private Methods******************/
}
